import { ChartOfAccountsTable } from "./chart-of-accounts-table";
import { useChartOfAccountsTable } from "./use-chart-of-accounts-table";

export const ChartOfAccounts = () => {
  const table = useChartOfAccountsTable({
    tableName: "chart-of-accounts",
    queryKeyPrefix: "chart-of-accounts",
  });

  return <ChartOfAccountsTable {...table} />;
};
